  import React, { useEffect } from 'react';
import ReactModal from 'react-modal';
import { ClipLoader } from 'react-spinners';
import type { CSSProperties } from 'styled-components';

import { MODAL_ELEMENTS } from '@/shared/constants';

import HiddenLoadingElement from './HiddenLoadingElement';

interface IProps {
  loading: boolean;
  appElement: string;
  parentSelector?: string;
}

const OVERFLOW_HIDDEN_CLASS = 'overflow_hidden';

const LoadingBackground: React.FC<IProps> = ({
  loading,
  appElement,
  parentSelector = MODAL_ELEMENTS.ROOT_MODAL,
}) => {
  const cssOverride: CSSProperties = {
    display: 'block',
    margin: '25% auto',
    color: '#fff',
  };

  const defaultStyle: ReactModal.Styles = {
    overlay: {
      position: 'fixed',
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
      overflow: 'auto',
      inset: '0px',
      zIndex: 999,
    },
    content: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      border: 'none',
      background: 'none',
    },
  };
  const appEl = document.getElementById(appElement)!;
  const getParenSelector = (): HTMLElement => document.getElementById(parentSelector)!;

  useEffect(() => {
    if (!loading) {
      if (document.body.classList.contains(OVERFLOW_HIDDEN_CLASS)) {
        document.body.classList.remove(OVERFLOW_HIDDEN_CLASS);
      }
      if (document.documentElement.classList.contains(OVERFLOW_HIDDEN_CLASS)) {
        document.documentElement.classList.remove(OVERFLOW_HIDDEN_CLASS);
      }
    }
  }, [loading]);

  return (
    <ReactModal
      isOpen={loading}
      style={defaultStyle}
      appElement={appEl}
      parentSelector={getParenSelector}
      bodyOpenClassName={OVERFLOW_HIDDEN_CLASS}
      htmlOpenClassName={OVERFLOW_HIDDEN_CLASS}
    >
      <ClipLoader color="white" cssOverride={cssOverride} size={50} />
      <HiddenLoadingElement />
    </ReactModal>
  );
};
export default LoadingBackground;
